import { render, staticRenderFns } from "./html.vue?vue&type=template&id=f48925ae&"
import script from "./html.vue?vue&type=script&lang=ts&"
export * from "./html.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports